import React, { Component } from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import { push } from "connected-react-router";
import ReactDataGrid from "react-data-grid";
import { updateMeasured, getMeasured } from "./_actions";
import Alert from "components/Alert";
import Page from "components/Page";
import PageBody from "components/PageBody";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";

import { Link } from "react-router-dom";

const drainageHeaders = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const otherHeaders = ["N/Ha", "Soil N", "Plant N", "Root N", "Stover N", "Soil moisture", "Soil moisture 600"];

const calendarMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const otherFields = ["nLossPerHa", "initialSoilN", "initialPlantN", "initialResidualRootN", "initialResidualStoverN", "initialSoilMoisture", "initialSoilMoisture600"];

class MeasuredValues extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { rows: [], rowsSet: false, errors: {} };
    }

    componentDidMount() {
        this.props.getMeasured(this.props.datasetId);
    }

    componentDidUpdate() {
        if (this.props.rows && this.props.rows.length > 0 && !this.state.rowsSet) {
            this.setState({ rowsSet: true });
            this.setState({ rows: this.props.rows });
        }
    }

    updateMeasuredResults = () => {
        const blocks = this.state.rows.map((b) => {
            let hasDrainage = false;
            const drainage = calendarMonths.map((c, i) => {
                hasDrainage = !hasDrainage ? b[c] > 0 : hasDrainage;
                return { month: i + 1, value: b[c] };
            });

            const block = { analysisId: b.analysisId, analysisName: b.analysisName, blockId: b.blockId, blockName: b.blockName, measurements: { drainageMM: hasDrainage ? drainage : undefined } };
            /* eslint-disable no-unused-vars */
            for (const k of otherFields) {
                if (b[k]) block.measurements[k] = b[k];
            }
            return block;
        });
        this.props.updateMeasured(this.props.datasetId, blocks, `/app/datasets/` + this.props.datasetId);
    };

    _rowGetter = (i) => {
        const val = this.state.rows[i];
        return val;
    };

    checkNumbers = (updated, rowToUpdate) => {
        const isNumeric = (value) => {
            return /\d/.test(value) && value < 1000;
        };

        let msg = "";
        calendarMonths.forEach(function (m) {
            if (updated[m]) {
                if (!isNumeric(updated[m])) {
                    msg = updated[m] + " for farm " + rowToUpdate.analysisName + " is not a valid number or is greater then 999. ";
                    return;
                }
            } else if (rowToUpdate[m] && !isNumeric(rowToUpdate[m])) {
                msg = rowToUpdate[m] + " for farm " + rowToUpdate.analysisName + " is not a valid number or is greater then 999. ";
                return;
            }
        });
        return msg;
    };

    handleRowsUpdated = ({ fromRow, toRow, updated }) => {
        let rows = this.state.rows.slice();

        let errors = this.state.errors;

        for (let i = fromRow; i <= toRow; i++) {
            let rowToUpdate = rows[i];
            errors[i] = this.checkNumbers(updated, rowToUpdate);
            let updatedRow = { ...rowToUpdate, ...updated };
            rows[i] = updatedRow;
        }

        this.setState({ errors });
        this.setState({ rows });
    };

    columns = (rows, headers, width) => {
        const cols = [
            {
                key: "blockId",
                name: "Block ID",
                editable: false,
                resizable: true,
                frozen: true,
                sortable: true,
                width: 270,
            },
            {
                key: "farmName",
                name: "Farm",
                editable: false,
                resizable: true,
                frozen: true,
                sortable: true,
                width: 220,
            },
            {
                key: "analysisName",
                name: "Analysis",
                editable: false,
                resizable: true,
                frozen: true,
                sortable: true,
                width: 220,
            },
            {
                key: "blockName",
                name: "Block",
                editable: false,
                resizable: true,
                frozen: true,
                sortable: true,
                width: 210,
            },
        ];
        rows.forEach(function (element, i) {
            cols.push({
                key: element,
                name: headers[i],
                editable: true,
                width: width,
            });
        });
        return cols;
    };

    render() {
        const { dataset, datasetId, online } = this.props;
        const rows = this.state.rows;
        const referrer = `/app/datasets/` + datasetId;

        const errors = Object.keys(this.state.errors)
            .filter((e) => this.state.errors[e])
            .map((e) => {
                return this.state.errors[e];
            });

        const sortRows = (rows, sortColumn, sortDirection) => {
            const comparer = (a, b) => {
                if (sortDirection === "ASC") {
                    return a[sortColumn] > b[sortColumn] ? 1 : -1;
                } else if (sortDirection === "DESC") {
                    return a[sortColumn] < b[sortColumn] ? 1 : -1;
                }
            };
            const results = sortDirection === "NONE" ? rows : [...rows].sort(comparer);
            return results;
        };

        return (
            <Page>
                <PageBody>
                    <Tile title={"Dataset: " + (dataset && dataset.name)} referrer={referrer}>
                        <TileBody>
                            <Panel title={"Measured drainage"} skyBlue>
                                <PanelBody>
                                    <div className="Grid">
                                        <div className="Grid-cell u-lg-width1of1">
                                            <ReactDataGrid
                                                enableCellSelect={true}
                                                columns={this.columns(calendarMonths, drainageHeaders, 75)}
                                                rowGetter={this._rowGetter}
                                                rowsCount={rows.length}
                                                minHeight={400}
                                                onGridSort={(sortColumn, sortDirection) => {
                                                    this.setState({ rows: sortRows(rows, sortColumn, sortDirection) });
                                                }}
                                                onGridRowsUpdated={this.handleRowsUpdated}
                                            />
                                        </div>
                                    </div>
                                    {errors.length > 0 &&
                                        errors.map((e) => {
                                            return <Alert type="error" text={e} />;
                                        })}
                                </PanelBody>
                            </Panel>
                            <Panel title={"Other measured"} skyBlue>
                                <PanelBody>
                                    <div className="Grid">
                                        <div className="Grid-cell u-lg-width1of1">
                                            <ReactDataGrid
                                                enableCellSelect={true}
                                                columns={this.columns(otherFields, otherHeaders, 120)}
                                                rowGetter={this._rowGetter}
                                                rowsCount={rows.length}
                                                minHeight={500}
                                                onGridSort={(sortColumn, sortDirection) => {
                                                    this.setState({ rows: sortRows(rows, sortColumn, sortDirection) });
                                                }}
                                                onGridRowsUpdated={this.handleRowsUpdated}
                                            />
                                        </div>
                                    </div>
                                    {errors.length > 0 &&
                                        errors.map((e) => {
                                            return <Alert type="error" text={e} />;
                                        })}
                                </PanelBody>
                            </Panel>

                            <div className="Modal-footer">
                                <div className="ButtonBar">
                                    <div className="ButtonBar-left">
                                        <Link to={referrer} className="Button Button--secondary">
                                            Cancel
                                        </Link>
                                    </div>
                                    <div className="ButtonBar-right">
                                        <button id="confirm-button" onClick={() => this.updateMeasuredResults()} disabled={!online || errors.length !== 0} className="Button">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </TileBody>
                    </Tile>
                </PageBody>
            </Page>
        );
    }
}

export default compose(
    withAppContext,
    withState((state, ownProps) => {
        let rows = [];
        if (state.dataset.currentDataset && state.dataset.currentDataset.measuredValues) {
            state.dataset.currentDataset.measuredValues.forEach(function (b) {
                let row = { analysisId: b.analysisId, farmName: b.farmName, analysisName: b.analysisName, blockId: b.blockId, blockName: b.blockName };

                if (b.measurements && b.measurements.drainageMM && b.measurements.drainageMM.length > 0) {
                    b.measurements.drainageMM.forEach((d) => (row[d.month] = d.value));
                }
                if (b.measurements) {
                    /* eslint-disable no-unused-vars */
                    for (const k of otherFields) {
                        if (b.measurements[k]) row[k] = b.measurements[k];
                    }
                }
                rows.push(row);
            });
        }

        return {
            auth: state.auth,
            online: state.app.online,
            datasetId: ownProps.match.params.datasetId,
            dataset: state.dataset.currentDataset && state.dataset.currentDataset.details,
            rows: rows,
            isLoading: state.app.isLoading,
        };
    }),
    withActions({ updateMeasured, getMeasured, push })
)(MeasuredValues);
